import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { CONDITION_TYPE } from '@core/js/components/system/TagManager/constants';
import { useAppSelector } from '@core/js/store/hooks';

import { CONFIG_TAG_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';
import { TAppConfigTag } from '@interlayer/js/components/system/TagManager/buzz/types';

export const useConfigTag = (type: CONFIG_TAG_TYPE, isGetAll = false) => {
    const configTags = useAppSelector((state) => state.activeConfigTags?.[type]);
    const { pathname } = useLocation();

    return useMemo(() => {
        if (isGetAll) {
            return configTags;
        }

        if (!configTags.length) {
            return null;
        }

        if (configTags.length === 1) {
            return configTags[0];
        }

        const sortedConfigTags = configTags.sort((a, b) => {
            if (a.tagName < b.tagName) {
                return -1;
            }

            if (a.tagName > b.tagName) {
                return 1;
            }

            return 0;
        });

        const tag = (sortedConfigTags as TAppConfigTag[]).find(({ conditions }) => {
            return conditions.find((condition) => {
                return condition.conditionTypeId === CONDITION_TYPE.page
                    && condition.config.onPageLaunch.trim()
                        .split(/(?:\s|,)\s*/)
                        .filter(Boolean)
                        .includes(pathname);
            });
        });

        if (tag) {
            return tag;
        }

        return sortedConfigTags[0];
    }, [configTags, isGetAll, pathname]);
};
